import {ChangeDetectionStrategy, Component, computed, inject, input, output, viewChild} from '@angular/core';
import {
    CustomMatSelectComponent
} from "../../../../../../../../shared/components/ui/custom-mat-select/custom-mat-select.component";
import {FileCardComponent} from "../../../../../../../../shared/components/ui/file-card/file-card.component";
import {MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {BannerSocialFileData} from "../../types/banners-social-modal.types";
import {defaultBannerSocialFileData} from "../../configs/default-banners-social-data";
import {EntityFileType} from "../../../../../../../../core/types/file.types";
import {BannerSocialFilesStateService} from "../../services/banner-social-files-state.service";
import {BannerSocialFilesService} from "../../services/banner-social-files.service";
import {BannerSocialFilePathStateService} from "../../services/banner-social-file-path-state.service";
import {ErrorService} from "../../../../../../../../core/services/error.service";
import {DeleteFileParams} from "../../../../../types/product-card-files.types";
import {RecordUpdateRequestParams} from "../../../../../../../../core/types/records-table.types";
import {prioritySelectData} from "../../configs/priority-select-data";
import {FormsModule} from "@angular/forms";

@Component({
  selector: 'div[app-banners-social-file-card]',
  imports: [
    CustomMatSelectComponent,
    FileCardComponent,
    MatFormField,
    MatInput,
    MatLabel,
    FormsModule
  ],
  templateUrl: './banners-social-file-card.component.html',
  styleUrl: './banners-social-file-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BannersSocialFileCardComponent {
  file = input<BannerSocialFileData>(defaultBannerSocialFileData);
  isEditModeActive = input<boolean>(false);
  bannerSocialEntityFileType = input<EntityFileType>('BANNERS');
  updateField = output<BannerSocialFileData>();
  customSelect = viewChild<CustomMatSelectComponent>('customSelect');

  public bannerSocialFilesStateService: BannerSocialFilesStateService = inject(BannerSocialFilesStateService);
  private bannerSocialFilesService: BannerSocialFilesService = inject(BannerSocialFilesService);
  private bannerSocialFilePathStateService: BannerSocialFilePathStateService = inject(BannerSocialFilePathStateService);
  private errorService: ErrorService = inject(ErrorService);

  public readonly prioritySelectData = prioritySelectData;
  public selectedPriority = computed(() => String(this.file().priority));

  public handleDelete(isImage: boolean): void {
    const params: DeleteFileParams = {
      path: this.bannerSocialFilePathStateService.pathFileState(),
      id: this.file().id
    };

    this.bannerSocialFilesService.deleteFile(params)
      .then(() => this.bannerSocialFilesStateService.deleteFileById(this.file().id));
  }

  public async handleUpdateField(key: string): Promise<void> {
    const params: RecordUpdateRequestParams = {
      path: this.bannerSocialFilePathStateService.pathFileState(),
      recordId: this.file().id,
      fieldName: key,
      value: this.file()[key]
    };

    await this.updateFieldBannerSocialData(params)
  }

  public async handleUpdatePriority(value: string): Promise<void> {
    const newPriority = Number(value);

    if (this.bannerSocialFilesStateService.hasFileWithPriority(newPriority)) {
      this.errorService.showErrorMessage('Такой приоритет уже установлен!');
      this.customSelect()?.resetToValue(this.selectedPriority());
      return;
    }

    const params: RecordUpdateRequestParams = {
      path: this.bannerSocialFilePathStateService.pathFileState(),
      recordId: this.file().id,
      fieldName: 'priority',
      value: newPriority
    };

    await this.updateFieldBannerSocialData(params);
  }

  private async updateFieldBannerSocialData(params: RecordUpdateRequestParams): Promise<void> {
    const updateData = await this.bannerSocialFilesService.updatedRecordField<BannerSocialFileData>(params).catch(() => this.file());
    this.updateField.emit(updateData);
  }
}
